import React, { useState } from 'react'
import loadable from '@loadable/component'

import { graphql, StaticQuery } from 'gatsby'

import Image from '../Image'
import Logos from '../Blocks/Logos'
import TestimonialCard from '../CardItems/TestimonialCard'
import Button from '../Inlines/Button'
import Accent from '../Inlines/Accent'
// import ModalButton from '../Modals/ModalButton'
// import ClutchModal from '../Blocks/ClutchModal'
// import ClutchWidget from '../Blocks/ClutchWidget'

import classNames from 'classnames'
import styles from './value-trust.module.sass'

// import TestimonialSlider from '../Wrappers/TestimonialSlider'
const LazyTestimonialSlider = loadable(() => import('../Wrappers/TestimonialSlider'))
const TestimonialSlider = props => <LazyTestimonialSlider {...props} />
// import Filters from '../Blocks/Filters'
const LazyFilters = loadable(() => import('../Blocks/Filters'))
const Filters = props => <LazyFilters {...props} />
// import TestimonialCarousel from '../Blocks/TestimonialCarousel'
const LazyTestimonialCarousel = loadable(() => import('../Blocks/TestimonialCarousel'))
const TestimonialCarousel = props => <LazyTestimonialCarousel {...props} />

const LazyClutchWidget = loadable(() => import('../Blocks/ClutchWidget'))
const ClutchWidget = props => <LazyClutchWidget {...props} />

const ValueTrust = ({ logos, testimonialTags, testimonials, noFooter, classes }) => {
  const [testimonialFilter, setTestimonialFilter] = useState('Featured')
  const matchTags = (current, target) => {
    return [target].filter(Boolean).every(tag => (current || []).includes(tag))
  }

  return (
    <section className={classNames(styles.valueTrust, classes)}>
      <div className="container pb-5">
        <div className="row">
          <div className={classNames(styles.sectionEntry, 'col-md')}>
            <h2 className={styles.sectionTitle}>Client Value &amp; Trust</h2>
            <Accent />
            <p className="pb-5">
              We partner with entrepreneurs, business and technology leaders to bring their innovative software-driven products, processes, and business
              ventures to life.
            </p>
          </div>
          <div className={classNames(styles.sectionAsset, 'col-md pt-lg-5')}>
            <ClutchWidget />
          </div>
        </div>
        <div className="row mt-3">
          <div className={classNames(styles.sectionEntry, 'col')}>
            <h3 className={styles.sectionSubTitle}>What Our Clients Say</h3>
            {testimonialTags ? (
              <>
                <Filters tags={testimonialTags} filter={testimonialFilter} setFilter={setTestimonialFilter} />
                <TestimonialSlider
                  options={{ dots: false }}
                  key={Date.now()}
                  count={testimonials.nodes.filter(testimonial => matchTags(testimonial.tags, testimonialFilter)).count}
                >
                  {testimonials.nodes
                    .filter(testimonial => matchTags(testimonial.tags, testimonialFilter))
                    .map((testimonial, i) => (
                      <TestimonialCard key={i} {...testimonial} />
                    ))}
                </TestimonialSlider>
              </>
            ) : (
              <TestimonialCarousel />
            )}
          </div>
        </div>
        {logos && (
          <div className="row mt-4">
            <Logos logos={logos} customStyles="col" />
          </div>
        )}
        {(logos || testimonialTags) && !noFooter && (
          <div className="row mt-4">
            <div className="col text-center">
              <Button to="/case-studies/" arrow>
                Explore Case Studies
              </Button>
            </div>
          </div>
        )}
        <Image className={styles.sectionBg} src="/images/backgrounds/value-trust-bg.svg" wrapper />
      </div>
    </section>
  )
}

export default props => (
  <StaticQuery
    query={graphql`
      {
        testimonials: allTestimonialsYaml(limit: 1000) {
          nodes {
            background
            text
            image
            name
            position
            tab
            tags
          }
        }
      }
    `}
    render={data => <ValueTrust {...props} {...data} />}
  />
)
